module.exports = __webpack_public_path__ + "static/media/Masker.99868daf.jpg";